import * as d3 from 'd3'
export default {
  methods: {

    draw_Stage(selection, stg, sn) {

      let parent = this.config.parent

      let stg_Group = selection
      .append('g')
      .attr('id', `SETP_GROUP_${sn}`)
      .attr('transform', `translate(0, 0)`)
      .call(this.exec_Procedure, stg, sn)

      stg_Group
      .append('rect')
      .attr('id', `STAGE_BOX_${sn}`)
      .attr('rx', 5).attr('ry', 5).attr('height', parent.height)
      .attr('fill', `url(#${this.localId}_SkyBlue_H2)`)
      .attr('stroke', '#E0E0DF').attr('stroke-width', 2)
      .attr('opacity', .5)

      stg_Group
      .append('text')
      .attr('id', `STAGE_TEXT_${sn}`)
      .attr('y', parent.height/2 + parent.tSize*0.36)
      .attr('fill', parent.tColor).attr('font-size', parent.tSize)
      .attr('text-anchor', 'middle').attr('font-weight', 500)
      .text(`${stg.NAME}`)

      let stepWidth = this.getNode(`#STAGE_TEXT_${sn}`)
      if(stepWidth < parent.minWidth) stepWidth = parent.minWidth
      d3.select(`#STAGE_BOX_${sn}`).attr('width', stepWidth)
      d3.select(`#STAGE_TEXT_${sn}`).attr('x', this.getNode(`#STAGE_BOX_${sn}`) / 2)

      stg.width = this.getNode(`#STAGE_BOX_${sn}`)
      stg.mx = stg.width / 2
      stg.ex = this.config.x[sn] + stg.width

      // Modal Forms
      selection
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Input.svg`)
      .attr('x', stg.width-84).attr('y', -27).attr('width', 22).attr('opacity', .4)
      .call(this.open_Window, {exeFunc: this.form_DataList, target: 'Input', idx: sn, width: 900, height: 720,})

      selection
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Exec.svg`)
      .attr('x', stg.width-54).attr('y', -27).attr('width', 22).attr('opacity', .4)
      .call(this.open_Window, {exeFunc: this.form_DataList, target: 'Exec', idx: sn, width: 900, height: 720,})

      selection
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Output.svg`)
      .attr('x', stg.width-24).attr('y', -27).attr('width', 22).attr('opacity', .4)
      .call(this.open_Window, {exeFunc: this.form_DataList, target: 'Output', idx: sn, width: 900, height: 720,})
    },


  }
}